import type React from 'react';

import type { SkeletonProps as ReactLoadingSkeletonProps } from 'react-loading-skeleton';
import ReactLoadingSkeleton from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';

export interface SkeletonProps extends ReactLoadingSkeletonProps {
  inverse?: boolean;
  inFlexContainer?: boolean;
}

const Skeleton: React.FC<SkeletonProps> = ({
  inverse = false,
  inFlexContainer = false,
  ...props
}) => {
  // Pass CSS var references so colors resolve at paint time and stay
  // reactive to theme switches (light/dark/barbie…) without needing
  // a ThemeProvider or MutationObserver.
  const baseColor = inverse
    ? 'var(--tw-background-brand-inverse)'
    : 'var(--tw-background-skeleton)';

  const highlightColor = inverse
    ? 'var(--tw-background-page)'
    : 'var(--tw-background-hover)';

  return (
    <ReactLoadingSkeleton
      {...props}
      baseColor={baseColor}
      containerClassName={
        inFlexContainer ? 'skeletonInFlexContainer' : undefined
      }
      duration={2}
      highlightColor={highlightColor}
    />
  );
};

export default Skeleton;
